import { c as _c } from "react/compiler-runtime";
import React from 'react';
import TogglePillGroup from 'components/consumer/TogglePillGroup';
const TypeRefinementList = t0 => {
  const $ = _c(8);
  const {
    items,
    refine
  } = t0;
  let t1;
  if ($[0] !== items) {
    t1 = (items || []).filter(_temp).map(_temp2);
    $[0] = items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const selectedItems = t1;
  let t2;
  if ($[2] !== items || $[3] !== refine) {
    t2 = items?.map(item_1 => ({
      id: item_1.value,
      label: item_1.label,
      count: item_1.count,
      onClick: () => {
        refine(item_1.value);
      }
    }));
    $[2] = items;
    $[3] = refine;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== selectedItems || $[6] !== t2) {
    t3 = <TogglePillGroup items={t2} selectedItems={selectedItems} groupName="Type" bindValues={true} />;
    $[5] = selectedItems;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default TypeRefinementList;
function _temp(item) {
  return item.isRefined;
}
function _temp2(item_0) {
  return item_0.value;
}